import axios from "axios";
import Qs from "qs";
import Element from "element-ui";
import Vue from "vue";


const httpServe = (method, url, data, isLoadd = true) => {
  let Public = { //公共参数

  }
  let httpDefaultOpts = { //http默认配置
    method: method,
    // baseURL: mainUrl,
    url: url,
    timeout: 30000,
    isLoadd: isLoadd,//是否显示加载动画
    params: Object.assign(Public, data),
    data: Qs.stringify(data)
  }
  // try {
  //   if (Object.prototype.toString.call(data) === '[object Array]') {//判断是数组还是对象
  //     httpDefaultOpts.data = data
  //   } else {
  //     httpDefaultOpts.data = Object.assign(Public, data)
  //   }
  // } catch (e) {
  //   httpDefaultOpts.data = Object.assign(Public, data)
  // }

  httpDefaultOpts['headers'] = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    // "openId": "ff808081695c1f08016999c2c50a0000",
    // "secret": "f12767f20e1a0f7601eb7bd154341d43a525f776dc4f6fae6f3bccf45877aef2",
    "Cache-Control": "no-cache",
    "If-Modified-Since": "0",
    // 'token': store.state.token
  }

  if (method == 'get') {
    delete httpDefaultOpts.data
    if (!!window.ActiveXObject || "ActiveXObject" in window) {//兼容某些IE get 请求会从缓存拿数据问题
      if (httpDefaultOpts.url.indexOf('?') != '-1') {
        httpDefaultOpts.url = httpDefaultOpts.url + '&timeStapIE=' + new Date().getTime()
      } else {
        httpDefaultOpts.url = httpDefaultOpts.url + '?timeStapIE=' + new Date().getTime()
      }
    }
  } else {
    delete httpDefaultOpts.params
  }

  let promise = new Promise(function (resolve, reject) {
    axios(httpDefaultOpts).then(
      (res) => {
        resolve(res)
      }
    ).catch(
      (response) => {
        reject(response)
      }
    )

  })
  return promise
}

let loading;
function startLoading() {
  loading = Vue.prototype.$loading({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
    // target: document.querySelector(".loading-area") //设置加载动画区域
  });
}

function endLoading() {
  loading.close();
}


//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.isLoadd) {
      showFullScreenLoading();
    }
    return config;
  },
  error => {
    tryHideFullScreenLoading();
    Element.Message.error({ message: "请求超时!" });
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    tryHideFullScreenLoading();
    let { data } = response;
    if (data.code !== 0) {
      // Element.Message({
      //   type: 'error',
      //   message: data.msg
      // })
    }
    if (data.code === 401) {
      window.location.href = '/#/login'
    }
    return data;
  },
  error => {
    tryHideFullScreenLoading();
    Element.Message({
      type: 'error',
      message: error.message
    })
  }
);

export default httpServe;